import { useEffect } from 'react';

import { tracking } from '@iwoca/frontend-tracking-library';

import { useLocale } from '../../hooks/useLocale';
import { useOffersDE } from '../../hooks/useOffers/useOffersDE';
import { useOffersUK } from '../../hooks/useOffers/useOffersUK';
import { getAmplitudeDefaultEventProperties } from '../../utils/amplitudeEvents';
import ApplicationLoader from '../ApplicationLoader/ApplicationLoader';
import SignupFormErrorDE from '../Offers/SignupFormError/SignupFormErrorDE';
import SignupFormErrorUK from '../Offers/SignupFormError/SignupFormErrorUK';

type TProps = {
  children: JSX.Element;
  isLoadingOrRedirecting: boolean;
  signupError: ReturnType<
    typeof useOffersUK | typeof useOffersDE
  >['signupError'];
};

const OffersCheck = ({
  children,
  isLoadingOrRedirecting,
  signupError,
}: TProps) => {
  const { isDE } = useLocale();

  useEffect(() => {
    tracking.ampli.stepLoaded({
      'Step name': 'Loading offers',
      ...getAmplitudeDefaultEventProperties(),
    });
  }, []);

  if (isLoadingOrRedirecting) {
    return <ApplicationLoader />;
  }

  if (signupError) {
    if (isDE) return <SignupFormErrorDE />;
    return <SignupFormErrorUK error={signupError} />;
  }

  return children;
};

export default OffersCheck;
